<template>
  <chart-card title="Clientes ativos" filter-button :filter-type.sync="filterType" :chart-loading="loading" :data="chartData" is-integer />
</template>

<script>
import ChartCard from '@/components/ChartCard.vue'
import { mapState } from 'vuex'
import { mapWaitingActions } from 'vue-wait'
import * as helpers from '@/config/helpers.js'
import { colors } from '@/config/colors.js'

export default {
  components: {
    ChartCard,
  },
  data: () => ({
    filterType: 'mensal',
    clientes: [],
    loading: true,
  }),
  computed: {
    ...mapState({
      stateFilters: (state) => state.filters,
    }),
    filtro() {
      return {
        unidades: this.stateFilters.unitsConfiguration,
        fidelidade: '1',
        segmentos: this.stateFilters.segments,
      }
    },
    chartData() {
      return {
        labels: [...this.clientes.map((object) => object.data)],
        datasets: [
          {
            label: 'Clientes ativos',
            backgroundColor: colors[0],
            strokeColor: colors[0],
            borderColor: colors[0],
            data: [...this.clientes.map((object) => object.valor)],
            fill: false,
          },
        ],
      }
    },
  },
  watch: {
    filterType() {
      this.getData()
    },
  },
  async mounted() {
    this.$bus.$on('filter', this.getData)

    this.$nextTick(async () => {
      await this.getData()
    })
  },
  destroyed() {
    this.$bus.$off('filter')
  },
  methods: {
    ...mapWaitingActions({
      clubeClientesAtivosChart: 'clientes-ativos',
    }),
    async getData() {
      try {
        this.loading = true
        if (this.filterType === 'mensal') {
          await this.clubeClientesAtivosChart({ group_field: 'ano,mes', ...this.filtro }).then((data) => {
            this.clientes = helpers.agrupamentoMensal(data, 'NUM_CLIENTES_ATIVOS')
          })
        }

        if (this.filterType === 'semanal') {
          await this.clubeClientesAtivosChart({ group_field: 'ano,semana', ...this.filtro }).then((data) => {
            this.clientes = helpers.agrupamentoSemanal(data, 'NUM_CLIENTES_ATIVOS')
          })
        }

        if (this.filterType === 'diario') {
          await this.clubeClientesAtivosChart({ group_field: 'anomesdia', ...this.filtro }).then((data) => {
            this.clientes = helpers.agrupamentoDiario(data, 'NUM_CLIENTES_ATIVOS')
          })
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
